import { EnumActivityStatus } from '../enums/activity-status.enum';
import { EnumRunPhase } from '../enums/run-phase.enum';
import { IActivity } from '../interfaces/activity.interface';

const PHASE_LABEL: Record<EnumRunPhase, string> = {
  [EnumRunPhase.CONTEXT]: 'Preparando contexto',
  [EnumRunPhase.CONNECTING]: 'Conectando recursos',
  [EnumRunPhase.MODEL]: 'Analisando solicitação',
  [EnumRunPhase.FINALIZING]: 'Finalizando resposta'
};

/**
 * Uma linha só: a operação em curso tem precedência sobre a fase, que é mais
 * genérica. Entre operações simultâneas vale a última anunciada.
 */
export const activityHeadline = (
  activities: IActivity[],
  phase: EnumRunPhase | null,
  isPending = false
): string | null => {
  if (isPending) {
    return 'Aguardando processamento';
  }

  const current = [...activities]
    .reverse()
    .find((activity) => activity.status === EnumActivityStatus.RUNNING);

  if (current) {
    return current.label;
  }

  return phase ? PHASE_LABEL[phase] : null;
};
